// This is only a visibility gate. The API independently validates membership
// of the selected profile against the authenticated identity in the tenant.
export function isActiveAdminDkp() {
  try {
    return JSON.parse(localStorage.getItem('perfilLogado') || '{}').perfil_acesso_nome === 'AdminDKP';
  } catch (_) { return false; }
}